import flatten from 'lodash/flatten';
import flattenDeep from 'lodash/flattenDeep';
import keys from 'lodash/keys';
import range from 'lodash/range';
import values from 'lodash/values';
import {extendTailwindMerge} from 'tailwind-merge';
import tailwindPreset from '../../../tailwind-preset';
import {colorTheme} from '../shared/theme/colorTheme';

const customTwMerge = extendTailwindMerge({
  theme: {
    colors: keys(tailwindPreset.theme.extend.colors()),
    opacity: keys(tailwindPreset.theme.extend.opacity),
    borderRadius: keys(tailwindPreset.theme.extend.borderRadius),
    borderWidth: keys(tailwindPreset.theme.extend.borderWidth),
    spacing: keys(tailwindPreset.theme.spacing),
    blur: keys(tailwindPreset.theme.blur),
  },
  classGroups: {
    'font-size': [{text: keys(tailwindPreset.theme.fontSize)}],
    'max-w': [
      {
        'max-w': [
          ...keys(tailwindPreset.theme.extend.maxWidth),
          {screen: keys(tailwindPreset.theme.screens)},
        ],
      },
    ],
    'min-w': [{'min-w': keys(tailwindPreset.theme.extend.minWidth)}],
    'max-h': [{'max-h': keys(tailwindPreset.theme.extend.maxHeight)}],
    'min-h': [{'min-h': keys(tailwindPreset.theme.extend.minHeight)}],
    w: [{w: keys(tailwindPreset.theme.extend.width)}],
    z: [{z: keys(tailwindPreset.theme.extend.zIndex)}],
    shadow: [{shadow: keys(tailwindPreset.theme.extend.boxShadow)}],
    animate: [{animate: keys(tailwindPreset.theme.extend.animation)}],
    // tailwind 플러그인들
    fonts: keys(tailwindPreset.theme.fonts()),
    'line-clamp': [
      {'line-clamp': ['none', ...range(1, 7).map(num => String(num))]},
    ],
    'scrollbar-hide': ['scrollbar-hide'],
    'grid-inner-border-cols': [
      ...range(1, 7).map(num => `grid-inner-border-cols${num}`),
    ],
    'inner-border-color': [
      {
        'inner-line': [...flattenDeep(values(colorTheme)).map(({tw}) => tw)],
      },
    ],
    'inner-border-radius': [
      {
        'inner-line-rounded': [...range(1, 20).map(num => `${num}px`), 'full'],
      },
    ],
    'safe-area-inset': [
      'm-safe',
      'mx-safe',
      'my-safe',
      'mt-safe',
      'mr-safe',
      'mb-safe',
      'ml-safe',
      'p-safe',
      'px-safe',
      'py-safe',
      'pt-safe',
      'pr-safe',
      'pb-safe',
      'bottom-button-safe-area',
      'pl-safe',
      't-safe',
      'r-safe',
      'b-safe',
      'l-safe',
    ],
    'inner-border': [
      {'inner-line': [...range(0.5, 10, 0.5).map(num => `${num}px`)]},
    ],
    'flex-center': ['flex-center'],
    'flex-center-full': ['flex-center-full'],
    'flex-center-full-grow': ['flex-center-full-grow'],
    'flex-center-col': ['flex-center-col'],
    'use-gpu': ['use-gpu'],
    'break-word-anywhere': ['break-word-anywhere'],
    'keep-word-anywhere': ['keep-word-anywhere'],
    blind: ['blind'],
  },
  conflictingClassGroups: {
    fonts: ['font-size', 'font-weight', 'leading'],
    'line-clamp': [
      'overflow',
      'display',
      '-webkit-box-orient',
      '-webkit-line-clamp',
    ],
    'use-gpu': ['transform'],
    'break-word-anywhere': ['word-break', 'overflow-wrap'],
    'keep-word-anywhere': ['word-break', 'overflow-wrap'],
    'inner-border': ['position'],
    'flex-center': ['display', 'justify-content', 'align-items'],
    'flex-center-full': [
      'display',
      'justify-content',
      'align-items',
      'flex-direction',
      'min-w',
      'h',
      'flex',
    ],
    'flex-center-full-auto': [
      'display',
      'justify-content',
      'align-items',
      'flex-direction',
      'min-w',
      'h',
      'flex',
    ],
    'flex-center-full-grow': [
      'display',
      'justify-content',
      'align-items',
      'flex-direction',
      'w',
      'h',
      'grow',
    ],
    'flex-center-col': [
      'display',
      'justify-content',
      'align-items',
      'flex-direction',
    ],
    blind: ['overflow', 'border', 'w', 'h', 'm', 'position'],
  },
});

export const twMerge = function (
  ...utilities: (
    | string
    | false
    | null
    | undefined
    | (string | false | null | undefined)[]
  )[]
) {
  const classLists = flatten(utilities);
  return customTwMerge(...classLists);
};
